import React from "react";
import Picture from "../components/Navbar Components/Picture";
import SignInForm from "./SignInForm";

const SignInPage = () => {
  return (
    <>
      <Picture />
      <SignInForm />
    </>
  );
};
export default SignInPage;